/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SmyGrid from '@/components/SmyGrid/SmyGrid';
import SmyGridItem from '@/components/SmyGrid/SmyGridItem';
import Badge from "vux/src/components/badge/index.vue";
import InlineXSwitch from "vux/src/components/inline-x-switch/index.vue";
import { getToDoCount } from '@/api';
export default {
  name: 'HomeTodo',
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 0
    },
    child: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showSetting: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 1
    } // cardId: {
    //   type: Number,
    //   required: true,
    // },

  },
  components: {
    SmyGrid: SmyGrid,
    SmyGridItem: SmyGridItem,
    Badge: Badge,
    InlineXSwitch: InlineXSwitch
  },
  data: function data() {
    return {
      badgeMap: {}
    };
  },
  computed: {
    isShow: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    }
  }
};